// Cross-repo contract helper (#30). Given the course slice, derive the
// rebook-from-devis payload fields for POST /courses:
//   - `selection`: the per-vélo checked sub-selection. WIRE FIELD = `selection`
//     (NOT `devis_selection`). Shape [{ velo_id, prestation_ids[], piece_ids[] }],
//     snake_case, velo_id = bike.id (the velo_id, NOT the pivot id).
//   - `source_visit_report_velo_ids`: pivot ids (visit_report_velos.id) of the
//     vélos with ≥1 checked line, mapped from each bike's
//     `source_visit_report_velo_id` (exposed additively by the api's
//     VisitReportSerializer). Empty when the api hasn't exposed the pivot yet
//     (graceful degrade — the rebook falls back to current behaviour).
//
// Kept as a pure function so RepairConfirmation and its tests share ONE source
// of truth and the contract surface can't drift between them.
const toInt = (value) =>
  typeof value === 'number' ? value : parseInt(value, 10);

export const buildDevisSelectionPayload = (course) => {
  const result = {};
  if (!course || typeof course !== 'object') return result;

  const selection = Array.isArray(course.devis_selection)
    ? course.devis_selection
    : [];

  // Only engage for the devis flow (a recorded selection, or a source report).
  if (selection.length === 0 && !course.source_visit_report_id) {
    return result;
  }

  // Sent regardless of pivot availability.
  result.selection = selection;

  const reportBikes =
    course.visit_report_data && Array.isArray(course.visit_report_data.bikes)
      ? course.visit_report_data.bikes
      : Array.isArray(course.bikes)
      ? course.bikes
      : [];

  const pivotByVeloId = new Map();
  reportBikes.forEach((bike) => {
    const veloId = toInt(bike && bike.id);
    const pivotId = toInt(bike && bike.source_visit_report_velo_id);
    if (Number.isFinite(veloId) && Number.isFinite(pivotId)) {
      pivotByVeloId.set(veloId, pivotId);
    }
  });

  const sourceVeloIds = selection
    .map((entry) => pivotByVeloId.get(entry && entry.velo_id))
    .filter((id) => Number.isFinite(id));
  if (sourceVeloIds.length > 0) {
    result.source_visit_report_velo_ids = sourceVeloIds;
  }

  return result;
};

export default buildDevisSelectionPayload;
